import {
	OPEN_MODAL,
	CLOSE_MODAL,
	UNAUTH_USER
} from '../actions/types'

const INITIAL_STATE = {
	currentModal: null
}

export default function (state = INITIAL_STATE, action){
	switch(action.type){
		case OPEN_MODAL:			
			return {
				...state,
				operation: action.operation,
				dataType: action.dataType,
				data: action.data,
				isVisible: 'yes'
			};
		case CLOSE_MODAL:
			if(action.errorOnly && state.operation != 'error'){
				return state
			}

			return {
				...state,
				data: null,
				operation: false,
				isVisible: 'no'
			}
		case UNAUTH_USER:
			return {
				...INITIAL_STATE
			}
		default:
			return state;
	}
}
